import * as yup from 'yup';

const isValidNonNegativeNumber = (value?: string) => {
  if (!value) {
    return true;
  }

  const num = parseFloat(value ?? '');
  return !Number.isNaN(num) && num >= 0;
};

const isValidOptionalNumber = (value?: string) => {
  if (!value) {
    return true;
  }

  return !Number.isNaN(parseFloat(value));
};

const manualWalletAdjustmentSchema = yup.object({
  transactionDirection: yup.string().oneOf(['CREDIT', 'DEBIT']).required('Direction is required'),
  transactionCategory: yup.string().required('Transaction category is required'),
  transactionReason: yup.string().required('Reason is required'),
  reference: yup.string().trim().required('Reference is required'),
  notes: yup
    .string()
    .trim()
    .required('User-facing notes are required')
    .max(100, 'Notes cannot exceed 100 characters'),
  childTransactions: yup
    .array()
    .of(
      yup.object({
        transactionAccount: yup.string().required(),
        amount: yup
          .string()
          .test('is-number', 'Enter a valid number', isValidOptionalNumber)
          .test('is-non-negative', 'Amount cannot be negative', isValidNonNegativeNumber),
      })
    )
    .test(
      'has-amount',
      'Enter an amount greater than zero for at least one account',
      // eslint-disable-next-line func-names
      function (childTransactions) {
        return (childTransactions || []).some(
          (childTransaction) => parseFloat(childTransaction?.amount || '0') > 0
        );
      }
    ),
});

export default manualWalletAdjustmentSchema;
